import React, { useEffect, useState } from 'react';
import { firestore } from '../../firebase';
import { useHistory } from 'react-router';
import { Container, Modal, Card, Form, Row, Col, Alert, Button } from 'react-bootstrap';

export default function CreateSale() {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const [vendedores, setVendedores] = useState([]);
    const [clientes, setClientes] = useState([]);
    const [vendedor, setVendedor] = useState("");
    const [cliente, setCliente] = useState("");
    const [metodoPago, setMetodoPago] = useState("");
    const [notas, setNotas] = useState("");
    const [showAlert, setShowAlert] = useState(false);
    const history = useHistory();

    function getVendedores() {
        setLoading(true);
        setError("");

        const vendedoresQuery = firestore.collection('vendedores').orderBy("codigo", "asc")
        vendedoresQuery.onSnapshot(querySnapshot => {
            const items = [];
            querySnapshot.forEach(doc => {
                const data = doc.data();
                items.push({
                    id: doc.id,
                    codigo: data.codigo,
                    nombre: data.nombre
                })
            })
            setVendedores(items);
            setLoading(false);
        })        
    }

    function getClientes() {
        setLoading(true);
        setError("");

        const clientesQuery = firestore.collection('clientes').orderBy("nombre", "asc");
        clientesQuery.onSnapshot(querySnapshot => {
            const items = [];
            querySnapshot.forEach(doc => {
                const data = doc.data();
                items.push({
                    id: doc.id,
                    nombre: data.nombre
                })
            })
            setClientes(items);
            setLoading(false);
        })        
    }

    function handleSubmit(e) {
        e.preventDefault();
        setLoading(true);
        setError("");

        if (!vendedor || !cliente || !metodoPago) {
            setError("Uno o más campos requeridos no llenados");
            setLoading(false);
            return null;
        }

        const newSale = {
            cliente: {
                id: cliente
            },
            vendedor: {
                id: vendedor
            },
            fecha: new Date(),
            productos: {
                cantidades: [],
                ids: []
            },
            confirmada: false,
            metodo_pago: metodoPago,
            notas
        }

        const vendedorRef = firestore.collection('vendedores').doc(vendedor);
        const clienteRef = firestore.collection('clientes').doc(cliente);
        const newSaleRef = firestore.collection('ventas').doc();


        firestore.runTransaction(async (t) => {
            const vendedorDoc = await t.get(vendedorRef);
            const clienteDoc = await t.get(clienteRef);

            newSale.vendedor.nombre = vendedorDoc.data().nombre;
            newSale.cliente.nombre = clienteDoc.data().nombre;

            await t.set(newSaleRef, newSale);
        }).then(() => {
            setShowAlert(true);
            setLoading(false);
        }).catch(() => {
            setError('Ocurrió un error inesperado, vuélvalo a intentar más tarde');
            setLoading(false);
        })
    }

    function handleClose() {
        setShowAlert(false);
        history.push("/sales");
    }

    useEffect(() => {
        getVendedores();
        getClientes();

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <Container 
        className="d-flex align-items-center justify-content-center"
        >
            <div className="w-100" style = {{ maxWidth: "550px"}}>
                <h2 className="text-center mt-3 mb-4">Crear Venta</h2>
                <Modal show={showAlert} onHide={handleClose}>
                    <Modal.Header>
                        <Modal.Title>Éxito</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        Se creó una venta. Para agregar productos, diríjase a la página 
                        de productos, elija un producto y seleccione la opción de 
                        Agregar a Venta. Seleccione el código de la venta y la cantidad del producto
                        a vender. Una vez que termine de agregar productos, diríjase a la venta y
                        seleccione la opción de Confirmar Venta.
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="primary" onClick={handleClose}>
                            Regresar
                        </Button>
                    </Modal.Footer>
                </Modal>
                <Card>
                    <Card.Body>
                        {error && <Alert variant="danger">{error}</Alert>}
                        <Form onSubmit={handleSubmit}>
                            <Row className="m-2">
                                <Col xs={12}>
                                    <Form.Group className="mb-3" id="venta-select-vendedor">
                                        <Form.Control
                                        as="select" custom
                                        value={vendedor}
                                        onChange={e => setVendedor(e.target.value)}
                                        disabled={loading}
                                        >
                                            <option value="">Escoja un vendedor</option>
                                            {vendedores 
                                            && vendedores.map(v => {
                                                return (
                                                    <option key={v.id} value={v.id}>{`${v.codigo} - ${v.nombre}`}</option>
                                                )
                                            })}
                                        </Form.Control>
                                    </Form.Group>
                                </Col>
                                <Col xs={12}>
                                    <Form.Group className="mb-3" id="venta-select-cliente">
                                        <Form.Control
                                        as="select" custom
                                        value={cliente}
                                        onChange={e => setCliente(e.target.value)}
                                        disabled={loading}
                                        >
                                            <option value="">Escoja un cliente</option>
                                            {clientes 
                                            && clientes.map(c => {
                                                return (
                                                    <option key={c.id} value={c.id}>{c.nombre}</option>
                                                )
                                            })}
                                        </Form.Control>
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row className="m-2">
                                <Col xs={12}>
                                    <Form.Group className="mb-3" id="venta-select-metodoPago">
                                        <Form.Control
                                        as="select" custom
                                        value={metodoPago}
                                        onChange={e => setMetodoPago(e.target.value)}
                                        disabled={loading}
                                        >
                                            <option value="">Escoja un método de pago</option>
                                            <option value="Efectivo">Efectivo</option>
                                            <option value="Datafono">Datáfono</option>
                                            <option value="Transferencia">Transferencia</option>
                                            <option value="Sinpe Movil">Sinpe Móvil</option>
                                            <option value="Otro">Otro</option>
                                        </Form.Control>
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row className="m-2">
                                <Form.Group className="mb-3" id="venta-notas">
                                    <Form.Label>Notas (opcional)</Form.Label>
                                    <Form.Control 
                                    as="textarea" rows={3}
                                    value={notas}
                                    onChange={e => setNotas(e.target.value)}
                                    disabled={loading}/>
                                </Form.Group>
                            </Row>
                            <Row className='m-2'>
                                <Col xs={3}>
                                    <Button disabled={loading} type="submit">Confirmar</Button>
                                </Col>
                            </Row>
                        </Form>
                    </Card.Body>
                </Card>
            </div>
        </Container>     
    )
}